import { getPageBackground } from '@tintoa/ui';

export interface BackgroundConfig {
  // Background image URL for login and signup pages
  // Set to null or empty string to use default gradients
  authBackgroundImage?: string | null;
}

// Default configuration – gradient colors come from @tintoa/ui (single source of truth)
export const backgroundConfig: BackgroundConfig = {
  // Set your background image URL here, or leave as null/undefined to use gradients
  //authBackgroundImage: null, // Example: "https://example.com/background.jpg"
  authBackgroundImage: "https://images.unsplash.com/photo-1506452305024-9d3f02d1c9b5?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", // Example: "https://example.com/background.jpg"
};

// Helper function to get background style for auth pages
export const getAuthBackgroundStyle = (isDarkTheme: boolean): string => {
  if (backgroundConfig.authBackgroundImage) {
    return `url(${backgroundConfig.authBackgroundImage}) center/cover`;
  }
  return getPageBackground(isDarkTheme ? 'dark' : 'light');
};

// Helper function to get background style for app (non-auth) pages
export const getAppBackgroundStyle = (isDarkTheme: boolean): string =>
  getPageBackground(isDarkTheme ? 'dark' : 'light');
